"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var apollo_link_1 = require("apollo-link");

var utils_1 = require("./utils");
/**
 * Token Refresh Link renew authentication token when it's expired.
 * @param {TokenRefreshLinkOptions} options - The token refresh link options.
 * @param {Function} options.onAuthSuccess - The callback which called when attempt to refresh authentication is success.
 * @param {Function} [options.onAuthError] - The callback which called when attempt to refresh authentication is failed.
 * @param {Function} [options.onIdTokenExpired] - The callback which called when id token is expired.
 */


var TokenRefreshLink =
/*#__PURE__*/
function (_apollo_link_1$Apollo) {
  _inherits(TokenRefreshLink, _apollo_link_1$Apollo);

  function TokenRefreshLink(_ref) {
    var _this;

    var onIdTokenExpired = _ref.onIdTokenExpired,
        onAuthError = _ref.onAuthError;

    _classCallCheck(this, TokenRefreshLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TokenRefreshLink).call(this));
    _this.onAuthError = onAuthError;
    _this.onIdTokenExpired = onIdTokenExpired;
    return _this;
  }

  _createClass(TokenRefreshLink, [{
    key: "request",
    value: function request(operation, forward) {
      var _this2 = this;

      return new apollo_link_1.Observable(function (observer) {
        var subscription = null;
        var handling = false;

        var handleTokenRefresh = function handleTokenRefresh() {
          _this2.handleTokenExpired().then(function () {
            var observable = forward(operation);

            if (subscription) {
              subscription.unsubscribe();
            }

            handling = false;
            subscription = observable.subscribe(subscriber);
          }).catch(function (err) {
            _this2.handleAuthFailed(err);

            handling = false;
            observer.complete();
          });
        };

        var subscriber = {
          complete: function complete() {
            if (!handling) {
              observer.complete();
            }
          },
          error: function error(_error) {
            var batchedErrors = R.pathOr([_error], ['response', 'parsed', 'errors'], _error);

            if (utils_1.hasIdTokenExpiredError(batchedErrors)) {
              handling = true;
              handleTokenRefresh();
            } else if (utils_1.hasRefreshTokenExpiredError(batchedErrors) || utils_1.hasTokenInvalidError(batchedErrors)) {
              _this2.handleAuthFailed();
            } else {
              observer.error(_error);
            }
          },
          next: function next(data) {
            var dataErrors = data.errors || [];

            if (utils_1.hasIdTokenExpiredError(dataErrors)) {
              handling = true;
              handleTokenRefresh();
            } else if (utils_1.hasRefreshTokenExpiredError(dataErrors) || utils_1.hasTokenInvalidError(dataErrors)) {
              _this2.handleAuthFailed();
            } else {
              observer.next(data);
            }
          }
        };
        subscription = forward(operation).subscribe(subscriber);
        return subscription;
      });
    }
  }, {
    key: "handleTokenExpired",
    value: function handleTokenExpired() {
      if (typeof this.onIdTokenExpired === 'function') {
        return this.onIdTokenExpired();
      }

      return Promise.reject();
    }
  }, {
    key: "handleAuthFailed",
    value: function handleAuthFailed(err) {
      if (typeof this.onAuthError === 'function') {
        this.onAuthError(err);
      }
    }
  }]);

  return TokenRefreshLink;
}(apollo_link_1.ApolloLink);

exports.TokenRefreshLink = TokenRefreshLink;